// mds-dojo — dojo/promise/Promise — FAITHFUL port of references/dojo/promise/Promise.js.
// Abstract public interface to a deferred; concrete then/cancel/is* are assigned by
// dojo/_base/Deferred onto each promise instance. finally/always/catch/otherwise/trace
// are the shared conveniences.
import lang from '../_base/lang';

function throwAbstract(): never {
  throw new TypeError('abstract');
}

const Promise = lang.extend(function Promise() { /* abstract */ }, {
  then: function (_callback?: any, _errback?: any, _progback?: any) { throwAbstract(); },
  cancel: function (_reason?: any, _strict?: any) { throwAbstract(); },
  isResolved: function () { throwAbstract(); },
  isRejected: function () { throwAbstract(); },
  isFulfilled: function () { throwAbstract(); },
  isCanceled: function () { throwAbstract(); },

  'finally': function (this: any, callback: any) {
    return this.then(function (value: any) {
      const vp = callback();
      if (vp && typeof vp.then === 'function') { return vp.then(function () { return value; }); }
      return value;
    }, function (reason: any) {
      const vp = callback();
      if (vp && typeof vp.then === 'function') { return vp.then(function () { throw reason; }); }
      throw reason;
    });
  },

  always: function (this: any, callbackOrErrback: any) {
    return this.then(callbackOrErrback, callbackOrErrback);
  },

  'catch': function (this: any, errback: any) {
    return this.then(null, errback);
  },

  otherwise: function (this: any, errback: any) {
    return this.then(null, errback);
  },

  trace: function (this: any) { return this; },
  traceRejected: function (this: any) { return this; },
  toString: function () { return '[object Promise]'; },
});

export default Promise;
